export const type_AUTH_FETCH_USER = 'AUTH/FETCH_USER'

export const type_POPUP_ONBOARD = 'POPUP/ONBOARD'
export const type_POPUP_LOADING = 'POPUP/LOADING'

export const type_MAIN_LOADING = 'MAIN/LOADING'
